import { useNavigate, useLocation } from "react-router-dom";
import { classNames } from "primereact/utils";
import TokenService from "../utils/TokenService";

const MainMenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isRegister = location.pathname === "/register";
    const isLogin = location.pathname === "/login";
    // const isVerifyEmail = location.pathname === "/verify-email";

    const homeClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_PUBLIC_SITE + "/";
    };

    const loginClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_ID_SITE + "/login";
    };

    const registerClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_ID_SITE + "/register";
    };

    const logoutClicked = (e) => {
        e.preventDefault();
        navigate("/logout");
    };

    return (
        <div className="layout-topbar shadow-4">
            <div className="layout-topbar-left">
                <button
                    type="button"
                    style={{ cursor: "pointer" }}
                    className="layout-topbar-logo p-link"
                    onClick={homeClicked}
                >
                    <img
                        id="app-logo"
                        src="/assets/layout/images/WallistLogo_Black.png"
                        alt="Wallist"
                        style={{ height: "3rem" }}
                    />
                </button>
                <div className="flex lg:hidden w-full justify-content-end">
                    <a href="#" className="font-bold mr-2" style={{ color: "black" }} onClick={homeClicked}>Home</a>
                    {isRegister && (
                        <a href="#" onClick={loginClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Login</a>
                    )}
                    {isLogin && (
                        <a href="#" onClick={registerClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Register</a>
                    )}
                    {TokenService.isLoggedIn() && (
                        <a href="#" onClick={logoutClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Logout</a>
                    )}
                </div>
            </div>
            <div
                className={classNames("layout-topbar-right", {
                    "layout-topbar-mobile-active": props.mobileTopbarActive,
                })}
            >
                <div className="layout-topbar-actions-left fs-large"></div>
                <div className="layout-topbar-actions-right">
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item">
                            <a href="#" onClick={homeClicked} style={{ color: "black" }} className="font-bold mr-2">Home</a>
                        </li>
                        {isRegister && (
                            <li className="layout-topbar-item">
                                <a href="#" onClick={loginClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Login</a>
                            </li>
                        )}
                        {isLogin && (
                            <li className="layout-topbar-item">
                                <a href="#" onClick={registerClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Register</a>
                            </li>
                        )}
                        {TokenService.isLoggedIn() && (
                            <li className="layout-topbar-item">
                                <a href="#" onClick={logoutClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Logout</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};
export default MainMenu;
